import './src/sass/main.scss'
import wrapWithProvider from './wrap-with-provider';

export const wrapRootElement = wrapWithProvider;